<template>
	<div class="signle-wrapper">
		<top :pagetitle="$t('重置密码')"></top>
		<div class="signle-main">
			<div class="form-panel">
				<div class="form-in">
					<div class="form-logo"><img :src="$helper.get('rule').app_logo" alt="" /></div>
					<div class="form-logo-text">{{$t('重置密码')}}</div>
					<el-tabs v-model="account_type" class="el-skin-tabs">
						<el-tab-pane :label="$t('手机')" name="0">
						</el-tab-pane>
						<!-- <el-tab-pane :label="$t('邮箱')" name="1">
						</el-tab-pane> -->
					</el-tabs>
					<div class="el-skin-tabs">
						<el-form ref="form" :model="form">
							<el-form-item v-if="account_type == '0'">
								<el-input v-model="form.phone" type="number" :placeholder="$t('请输入手机号码')"></el-input>
							</el-form-item>
							<el-form-item v-if="account_type == '1'">
								<el-input v-model="form.email" :placeholder="$t('请输入邮箱')"></el-input>
							</el-form-item>
							<el-form-item>
								<div class="input-row flex">
									<div class="flex-col">
										<el-input v-model="form.code" :placeholder="$t('请输入验证码')"></el-input>
									</div>
									<el-button class="btn-getCode" type="warning"
										@click="account_type == '1' ? sendEmailCode() : sendPhoneCode()">
										{{ $t(sendCodeText) }}
									</el-button>
								</div>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" round @click="checkeAccount">
									{{$t('下一步')}}
								</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
		<bottom></bottom>
	</div>
</template>
<script>
	import {
		checke_account_api,
		send_email_code_api,
		send_phone_code_api,
		login_checke_account_api
	} from '@/api/login'
	import top from '@/components/top';
	import bottom from '@/components/bottom';
	export default {
		components: {
			bottom,
			top
		},
		data() {
			return {
				sendCodeing: false,
				sendCodeLoading: false,
				sendCodeText: '发送',
				sendCodeSec: 60,
				account_type: '0',
				isdisabled:true,
				form: {
					phone: '',
					email: "",
					password: '',
					checked: false,
					code: '',
				}
			};
		},
		methods: {
			// 验证
			async checkeAccount() {
				
				if (this.form.phone == "") {
					this.errorTips("请输入手机号");
					return;
				}
				const phoneReg = /^(0\d{9}|\d{9})$/;
				if (!phoneReg.test(this.form.phone)) {
					this.errorTips('请输入正确的手机格式');
					return;
				}
				if (this.form.code == "") {
					this.errorTips("请输入验证码");
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await login_checke_account_api({
					account: this.form.phone,
					code:this.form.code
				}).then(res => {
					if (res && res.data.code == 1) {
						// this.successTips(res.data.msg);
						console.log(res.data.msg)
						this.$router.push({
							path: '/reset-new',
							query: {
								account: this.form.phone
							}
						});
					} else {
						this.errorTips(res.data.msg);
					}
					loading.close()
				});
			},
			// 获取手机验证码
			async sendPhoneCode() {
				console.log('sendPhoneCode')
				let _this = this;
				if (_this.sendCodeing) {
					return
				}
				if (this.form.phone == "") {
					this.errorTips("请输入手机号");
					return;
				}
				_this.sendCodeLoading = true;
				await send_phone_code_api({
					phone: this.form.phone,
					type: 2
				}).then(res => {
					_this.sendCodeLoading = false;
					if (res && res.data.code == 1) {
						this.countdown()
						this.successTips(res.data.msg);
					} else {
						this.errorTips(res.data.msg);
					}
				});
			},
			sendEmailCode() {
				console.log('sendEmailCode')
				if (this.sendCodeing) return;
				if (this.form.email == "") {
					this.errorTips('邮箱不能为空');
					return;
				}
				const mailReg = /^([a-zA-Z0-9_.-]+)@([a-zA-Z0-9_-]+).([a-zA-Z0-9_-]+)(.[a-zA-Z0-9_-]+)*$/;
				if (mailReg.test(this.form.email)) {
					this.getMailCode_two();
				} else {
					this.errorTips('请输入正确的邮箱格式');
					return;
				}
			},
			async getMailCode_two() {
				console.log('getMailCode_two')
				let _this = this;
				if (_this.sendCodeing) {
					return
				}
				_this.sendCodeing = true;
				_this.sendCodeLoading = true;
				let info = {
					email: _this.form.email,
					type: '2'
				}
				await send_email_code_api(info).then(res => {
					_this.sendCodeLoading = false;
					console.log(res,'res.data')
					if (res && res.data.code == 1) {
						_this.countdown();
						_this.successTips(res.data.msg);
					} else {
						console.log(res,'res.data')
						_this.sendCodeing = false;
						_this.errorTips(res.data.msg);
					}
				});
			},
			countdown() {
				this.sendCodeing = true;
				this.sendCodeText = this.sendCodeSec + "s";
				let clock = window.setInterval(() => {
					this.sendCodeSec--;
					this.sendCodeText = this.sendCodeSec + "s";
					if (this.sendCodeSec < 0) {
						window.clearInterval(clock);
						this.sendCodeText = this.$t("重新发送");
						this.sendCodeSec = 60;
						this.sendCodeing = false;
					}
				}, 1000);
			},
			onSubmit() {
				this.goUrl('/reset-new')
			}

		},
		mounted() {}
	}
</script>
<style scoped>
	@import url("../../assets/css/signle.css");

	.form-links {
		justify-content: center;
	}
</style>